import {chainPush, chainExecute} from "@/FunctionKit.js"
import {changeIframe} from "@/TopIFrame.js"
import {setEmpowerBg} from "@/InitBg.js"
import {loadModule} from "@/LoadModule.js"

	import set from 'lodash-es/set';
	import queryString from 'query-string';
function CreateUuid(len = 8,radix = 10)
{
        let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
        let uuid = [],i
        let rdx = radix || chars.length
        if (len)
        {
            for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * rdx]
        }
        else
        {
            let r
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
            uuid[14] = '4'
            for (i = 0; i < 36; i++)
            {
                if (!uuid[i])
                {
                    r = 0 | Math.random() * 16
                    uuid[i] = chars[i === 19 ? r & 0x3 | 0x8 : r]
                }
            }
        }
        return Number(uuid.join(''))
}
	export const routerPush = (path) =>
	{
	    if (!path) return;
	    setEmpowerBg();
	    try
	    {
	        if (window.top === window.self)
	        {
	            history.pushState(path, 'Codigger', path);
	            changeIframe(path);
	        }
	        else
	        {
	            location.href = '/';
	        }
	    }
	    catch (error)
	    {
	        console.error('router push', error);
	    }
	};
	export const changeDesktop = async (setting = {}) =>
	{
	    const $iframe = document.getElementById('codigger-main');
	    $iframe.contentWindow.location.reload();
	};
	export const routerRefresh = () =>
	{
	    chainPush(initRouter);
	    chainExecute();
	}
	export const initRouter = () =>
	{
	    return new Promise((resolve) =>
	    {
	        const indexPath = localStorage.getItem('CodiggerIndexPath');
	        changeIframe(location.pathname === '/' ? indexPath || '' : location.href.replace(location.origin, ''));
	        window.addEventListener('popstate', () =>
	        {
	            changeIframe(location.href.replace(location.origin, ''));
	        });
	        resolve();
	    });
	};
	export const analyzeToken = (myToken) =>
	{
	    if (!myToken) return;
	    const base64Data = myToken.split('.');
	    const userData = JSON.parse(decodeURIComponent(escape(window.atob(base64Data[1].replace(/-/g, '+').replace(/_/g, '/')))));
	    if (userData.router_strategy.candidate)
	    {
	        userData.router_strategy.candidate += '/api/websocket/host_channel';
	    }
	    if (userData.router_strategy.discovery)
	    {
	        userData.router_strategy.discovery += '/api/websocket/host_channel';
	    }
		userData.router_strategy.local='ws://localhost:9001/api/websocket/host_channel';
        userData.virtual_mudem_id = userData.virtual_mudem_id + '-' + CreateUuid(4);
	    localStorage.setItem('oauth-token', myToken);
	    localStorage.setItem('userInfo', JSON.stringify(userData));
	    return userData
	}
	export const removeToken = () =>
	{
	    localStorage.removeItem('oauth-token')
	}
	export const initUser = async (myToken) =>
	{
	    set(window, 'top.Empower.router.routerPush', routerPush);
	    set(window, 'top.Empower.Module', { loadModule });
	    return new Promise((resolve, reject) =>
	    {
	        const queryParams = queryString.parse(location.search)
	        const oauthToken = queryParams?.jwtToken || myToken || localStorage.getItem('oauth-token')
	        if (!oauthToken)
	        {
	            return resolve()
	        }
            const codiggerSymbol = queryParams['codigger-symbol']
            if (!localStorage.getItem('codigger-symbol') && !!codiggerSymbol)
            {
                localStorage.setItem('codigger-symbol', codiggerSymbol)
            }
	        return resolve(analyzeToken(oauthToken))
	    })
	}
	export const getUserInfo = () =>
	{
	    return JSON.parse(localStorage.getItem('userInfo'))
	}

